<template>
  <span>
    {{ value }}
    <span class="ma-1" title="Позвонить" @click="$root.$emit('ddd', value)">
      <v-icon color="primary" small>fas fa-pen-nib</v-icon>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    model: Object,
  },
  computed: {},
};
</script>
